import React from "react";
import {connect} from "react-redux";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Loading from "features/components/loading";
import {startPeopleFavoritesGet} from "./reducer";
import {
    peopleFavoritesData,
    peopleFavoritesErrorSelector,
    peopleFavoritesLoading
} from "./selectors";
import PeopleCard from "features/components/people-card";
import {HorizontalScrollSection} from "features/components/horizontal-scroll-section";
import {peopleSearchFiltersActive} from "features/pages/people/search/selectors";

/* istanbul ignore next */
const mapStateToProps = state => ({
    data: peopleFavoritesData(state),
    loading: peopleFavoritesLoading(state),
    error: peopleFavoritesErrorSelector(state),
    filters_active: peopleSearchFiltersActive(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    startPeopleFavoritesGet
};

export const PeopleFavorites = (props) => {

    const {data, loading, error, filters_active} = props;
    const {startPeopleFavoritesGet} = props;

    React.useEffect(() => {
        startPeopleFavoritesGet();
    }, [startPeopleFavoritesGet])

    if(data.profiles.length + data.companies.length === 0 || filters_active) return null;

    return <div>
        {error.inError && <Text size={16} color={"danger"}>{__(error.error)}</Text>}
        {loading && <Loading />}
        {data.profiles.length > 0 && <div className="home-section">
            <Title size={34}>{__("people.titles.favorites.profiles")}</Title>
            <HorizontalScrollSection type={"light"}>
                {
                    data.profiles.map(item => <PeopleCard key={item.id} item={item}/>)
                }
            </HorizontalScrollSection>
        </div>}
        {data.companies.length > 0 && <div className="home-section">
            <Title size={34}>{__("people.titles.favorites.companies")}</Title>
            <HorizontalScrollSection type={"light"}>
                {
                    data.companies.map(item => <PeopleCard key={item.id} item={item}/>)
                }
            </HorizontalScrollSection>
        </div>}
    </div>
}

export default connect(mapStateToProps, mapDispatchToProps)(PeopleFavorites);